import { render, staticRenderFns } from "./DialogConfirmacao.vue?vue&type=template&id=149923ae"
import script from "./DialogConfirmacao.vue?vue&type=script&lang=js"
export * from "./DialogConfirmacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports